import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledIconButton } from '../../components/IconButton/IconButton.styles';

/** @class PropertyCardPhotoNavigationControlsMixin */
/** @method */
export var PhotoCarouselNavControlsMixin = function PhotoCarouselNavControlsMixin(props) {
  return token({
    iconColor: 'PhotoCarousel.controlIcon.color',
    iconFilterNext: 'PhotoCarousel.controlIcon.next.filter',
    iconFilterPrevious: 'PhotoCarousel.controlIcon.previous.filter'
  }, function (_ref) {
    var iconColor = _ref.iconColor,
      iconFilterNext = _ref.iconFilterNext,
      iconFilterPrevious = _ref.iconFilterPrevious;
    return css(["position:static;z-index:1;", "{position:absolute;border-color:transparent;height:100%;&:nth-child(1){left:0;", "{filter:", ";}}&:nth-child(2){right:0;", "{filter:", ";}}&:active,&:hover{background-color:transparent;border-color:transparent;color:", ";}&:focus{box-shadow:none;}&[disabled]{pointer-events:auto;}}"], StyledIconButton, StyledIcon, iconFilterPrevious, StyledIcon, iconFilterNext, iconColor);
  })(props);
};